import axios from 'axios'
import uniq from 'lodash/uniq'

export const state = {
  campaignForm: {
    deleteFiles: [],
    deleteAssets: [],
  },
  campaigns: [],
  campaign: '',
  flights: [],
  flight: false,
  assets: [],
  asset: false,
  screenshots: [],
  notes: [],
  creatives: [],
  creative: [],
  creativeTypes: [],
  adUnits: [],
  gamPresets: []
}

export const getters = {
  campaignForm: (state) => state.campaignForm,
  campaign: (state) => state.campaign,
  campaigns: (state) => state.campaigns,
  flights: (state) => state.flights,
  flight: (state) => state.flight,
  assets: (state) => state.assets,
  asset: (state) => state.asset,
  screenshots: (state) => state.screenshots,
  notes: (state) => state.notes,
  creativeTypes: (state) => state.creativeTypes,
  creatives: (state) => state.creatives,
  adUnits: (state) => state.adUnits,
  gamPresets: (state) => state.gamPresets,
}

export const mutations = {
  SET_CAMPAIGN_FORM(state, payload) {
    state.campaignForm[payload.section] = payload.data
  },
  SET_DELETE_FILE_FORM(state, payload) {
    state.campaignForm.deleteFiles = uniq([...state.campaignForm.deleteFiles, payload])
  },
  SET_DELETE_ASSETS_FORM(state, payload) {
    state.campaignForm.deleteAssets = uniq([...state.campaignForm.deleteAssets, payload])
  },
  SET_CAMPAIGN(state, payload) {
    state.campaign = payload || ''
  },
  SET_CAMPAIGNS(state, payload) {
    state.campaigns = payload
  },
  SET_FLIGHTS(state, payload) {
    state.flights = payload
  },
  SET_FLIGHT(state, payload) {
    state.flight = payload
  },
  SET_ASSETS(state, payload) {
    state.assets = payload
  },
  SET_ASSET(state, payload) {
    state.asset = payload
  },
  SET_SCREENSHOTS(state, payload) {
    state.screenshots = payload
  },
  SET_NOTES(state, payload) {
    state.notes = payload
  },
  SET_CREATIVETYPE(state, payload) {
    state.creativeTypes = payload
  },
  SET_CREATIVES(state, payload) {
    state.creatives = payload
  },
  SET_CREATIVE(state, payload) {
    state.creative = payload
  },
  SET_ADUNITS(state, payload) {
    let units = payload
    let grouped = []
    if (payload) {
      units = payload?.map((item) => {
        return {
          id: item.gam_id,
          name: item.name,
          type: item.type,
        }
      })

      grouped = [
        {
          label: 'Presets',
          options: units
            .filter((item) => item.type === 'preset')
            .map((item) => ({
              id: item.id,
              name: item.name,
              type: item.type,
            })),
        },
        {
          label: 'Ad Units',
          options: units
            .filter((item) => item.type === 'adunit')
            .map((item) => ({
              id: item.id,
              name: item.name,
              type: item.type,
            })),
        },
      ]
    }
    state.adUnits = grouped
  },
  SET_GAM_PRESETS (state, payload) {
    state.gamPresets = payload
  },
  CLEAR_CAMPAIGN_FORM(state) {
    state.campaignForm = {
      deleteFiles: [],
      deleteAssets: [],
    }
  },
}

export const actions = {
  async saveCampaignForm({ commit, state }, payload) {
    const url = '/api/social-products/social-boost/campaign' + (payload.method === 'create' ? '' : `/${state.campaign.id}`)
    if (payload.method !== 'create') {
      state.campaignForm._method = 'put'
    } else {
      delete state.campaignForm._method
    }

    try {
      const { data } = await axios({
        method: 'post',
        url,
        data: state.campaignForm,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })

      if (payload.clearData === undefined || payload.clearData === true) {
        commit('CLEAR_CAMPAIGN_FORM')
      }

      return data
    } catch (error) {
      return false
    }
  },
  async saveFlightForm({ commit, state }, payload) {
    const url =
      `/api/social-products/social-boost/campaign/${payload?.campaign || state.campaign.id}/flight` +
      (payload?.method === 'create' ? '' : `/${state.flight.id}`)
    if (payload?.method !== 'create') {
      state.campaignForm._method = 'put'
    } else {
      delete state.campaignForm._method
    }

    try {
      const { data } = await axios({
        method: 'post',
        url,
        data: state.campaignForm,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })

      if (payload?.clearData === undefined || payload?.clearData === true) {
        commit('CLEAR_CAMPAIGN_FORM')
      }
      return data
    } catch (error) {
      return false
    }
  },
  async saveAssetsForm({ commit, state }, payload) {
    const url =
      `/api/social-products/social-boost/flight/${payload.flight_id}/asset` + (payload.method === 'create' ? '' : `/${payload.asset_id}`)
    if (payload.method !== 'create') {
      state.campaignForm._method = 'put'
    } else {
      delete state.campaignForm._method
    }

    try {
      const { data } = await axios({
        method: 'post',
        url,
        data: state.campaignForm,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      commit('CLEAR_CAMPAIGN_FORM')
      return data
    } catch (error) {
      console.log(error)
      return false
    }
  },
  async saveMultiAssetsForm({ commit, state }, payload) {
    const url = `/api/social-products/social-boost/flight/${payload.flight_id}/multi-asset-update`

    try {
      const { data } = await axios({
        method: 'post',
        url,
        data: state.campaignForm,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      commit('CLEAR_CAMPAIGN_FORM')
      return data
    } catch (error) {
      console.log(error)
      return false
    }
  },
  async getCampaign({ commit, dispatch }, payload) {
    commit('app/SET_LOADING', payload?.pageLoading === undefined ? true : payload?.pageLoading, { root: true })
    const { data } = await axios.get(`/api/social-products/social-boost/campaign/${payload.id}`)
    commit('SET_CAMPAIGN', data)
    commit('app/SET_LOADING', false, { root: true })
    await dispatch('getAdUnits')
    await dispatch('getGamPresets')
    return data
  },
  async getCampaigns({ commit }, payload) {
    const queryString = new URLSearchParams(payload).toString()
    commit('app/SET_LOADING', true, { root: true })
    const { data } = await axios.get(`/api/social-products/social-boost/campaign?${queryString}`)
    commit('SET_CAMPAIGNS', data)
    commit('app/SET_LOADING', false, { root: true })
    return data
  },
  async deleteCampaign({ dispatch }, payload) {
    const { data } = await axios.delete(`/api/social-products/social-boost/campaign/${payload.id}`)
    if (!payload.redirect) {
      dispatch('getCampaigns', { page: 1 })
    }

    return data
  },
  async getFlights({ commit }, id) {
    commit('app/SET_LOADING', true, { root: true })
    const { data } = await axios.get(`/api/social-products/social-boost/campaign/${id}/flight`)
    commit('SET_FLIGHTS', data)
    commit('app/SET_LOADING', false, { root: true })
    return data
  },
  async getFlight({ commit }, payload) {
    commit('app/SET_LOADING', payload?.pageLoading === undefined ? true : payload?.pageLoading, { root: true })
    const { data } = await axios.get(`/api/social-products/social-boost/campaign/${payload.id}/flight/${payload.flight_id}`)
    commit('SET_FLIGHT', data)
    commit('app/SET_LOADING', false, { root: true })
    return data
  },

  async deleteFlight({ dispatch, state }, payload) {
    const { data } = await axios.delete(`/api/social-products/social-boost/campaign/${payload.id}/flight/${payload.flight_id}`)
    if (!payload.redirect) {
      dispatch('getCampaign', { id: payload.id })
    }

    return data
  },
  async deleteAsset({ dispatch, state }, payload) {
    const { data } = await axios.delete(`/api/social-products/social-boost/flight/${payload.flight_id}/asset/${payload.asset_id}`)
    if (!payload.redirect) {
      dispatch('getCampaign', { id: payload.id })
    }

    return data
  },
  async copyAsset({ dispatch }, payload) {
    try {
      const { data } = await axios.post(
        `/api/social-products/social-boost/flight/${payload.currentFlight}/asset/${payload.asset_id}/copy`,
        {
          flight_id: payload.flight_id,
          flightName: payload.flightName,
        }
      )

      if (payload.currentFlight === payload.flight_id) {
        dispatch('getCampaign', { id: payload.campaignId })
      }

      return data
    } catch (error) {
      console.error('Error copying asset:', error.response?.data || error.message)
      throw error
    }
  },
  async getAsset({ commit }, payload) {
    commit('app/SET_LOADING', true, { root: true })
    const { data } = await axios.get(`/api/social-products/social-boost/flight/${payload.flight_id}/asset/${payload.asset_id}`)
    commit('SET_ASSET', data)
    commit('app/SET_LOADING', false, { root: true })
    return data
  },
  async sendToReview({ dispatch }, payload) {
    const { data } = await axios.post(
      `/api/social-products/social-boost/campaign/${payload.campaign_id}/flight/${payload.flight_id}/change-status`,
      {
        status: 2,
      }
    )
    return data
  },
  async approve({ dispatch }, payload) {
    const { data } = await axios.post(
      `/api/social-products/social-boost/campaign/${payload.campaign_id}/flight/${payload.flight_id}/change-status`,
      {
        status: 3,
      }
    )
    return data
  },
  async active({ dispatch }, payload) {
    const { data } = await axios.post(
      `/api/social-products/social-boost/campaign/${payload.campaign_id}/flight/${payload.flight_id}/change-status`,
      {
        status: 6,
      }
    )
    return data
  },
  async requestRevision({ dispatch }, payload) {
    const { data } = await axios.post(
      `/api/social-products/social-boost/campaign/${payload.campaign_id}/flight/${payload.flight_id}/change-status`,
      {
        status: 1,
        instructions: payload.instructions,
      }
    )
    return data
  },
  async updateCampaignCpm({ dispatch }, payload) {
    try {
      const { data } = await axios.post(`/api/social-products/social-boost/campaign/${payload.campaign_id}/change-cpm`, {
        cpm: payload.cpm,
      })

      return data
    } catch (error) {
      console.error('Error updating CPM:', error.response?.data || error.message)
      throw error
    }
  },
  async duplicateCampaign({ dispatch }, payload) {
    try {
      const { data } = await axios.post(`/api/social-products/social-boost/duplicate/campaign/${payload.campaignId}`, {})
      dispatch('getCampaigns', { page: 1 })
      return data
    } catch (error) {
      console.error('Error copying campaign:', error.response?.data || error.message)
      throw error
    }
  },
  async duplicateFlight({ dispatch }, payload) {
    try {
      const { data } = await axios.post(`/api/social-products/social-boost/duplicate/flight/${payload.flightId}`, {})
      dispatch('getCampaign', { id: payload.campaignId })
      return data
    } catch (error) {
      console.error('Error copying campaign:', error.response?.data || error.message)
      throw error
    }
  },
  async deleteScreenshot({ dispatch, state }, payload) {
    const { data } = await axios.delete(`/api/social-products/social-boost/screenshots/${payload.screenshot_id}`)
    return data
  },

  async getScreenshots({ commit }, payload) {
    const { data } = await axios.get(`/api/social-products/social-boost/screenshots/${payload.flight_id}`, {})
    commit('SET_SCREENSHOTS', data)

    return data
  },
  async getNotes({ commit }, payload) {
    const { data } = await axios.get(`/api/social-products/social-boost/notes/${payload.flight_id}`, {})
    commit('SET_NOTES', data)

    return data
  },
  async getCreativeTypes({ commit }, payload) {
    const { data } = await axios.get(`/api/social-products/social-boost/creatives/types/${payload.campaignId}`)
    commit('SET_CREATIVETYPE', data)
    return data
  },
  async saveCreativesForm({ commit, state }, payload) {
    const url = `/api/social-products/social-boost/creatives/${payload.asset_id}`
    const formData = new FormData()

    formData.append('gam_ad_unit_preset_id', payload.gam_ad_unit_preset_id)
    formData.append('name', payload.name)

    payload.files.forEach((file, index) => {
      formData.append(`files[${index}][name]`, file.name)
      formData.append(`files[${index}][size]`, file.size)
      formData.append(`files[${index}][type]`, file.type)
      formData.append(`files[${index}][raw]`, file.raw)
    })

    try {
      const { data } = await axios.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })

      commit('CLEAR_CAMPAIGN_FORM')
      return data
    } catch (error) {
      console.error(error)
      return false
    }
  },
  async getCreatives({ commit }, payload) {
    const { data } = await axios.get(`/api/social-products/social-boost/creatives/${payload.flight_id}`)
    commit('SET_CREATIVES', data)
    return data
  },
  async getCreative({ commit }, payload) {
    const { data } = await axios.get(`/api/social-products/social-boost/creatives/${payload.creative_id}/get-single`)
    commit('SET_CREATIVE', data)
    return data
  },
  async deleteCreative({ dispatch, state }, payload) {
    const { data } = await axios.delete(`/api/social-products/social-boost/creatives/${payload.creative_id}`)
    return data
  },
  async deleteFile({}, payload) {
    const { data } = await axios.post(`/api/social-products/social-boost/creatives/remove-file/${payload.file_id}`, {})
    return data
  },
  async addCreativeFiles({}, payload) {
    const url = `/api/social-products/social-boost/creatives/${payload.creative_id}/add-files`
    const formData = new FormData()

    payload.files.forEach((file, index) => {
      formData.append(`files[${index}][name]`, file.name)
      formData.append(`files[${index}][size]`, file.size)
      formData.append(`files[${index}][type]`, file.type)
      formData.append(`files[${index}][raw]`, file.raw)
    })

    try {
      const { data } = await axios.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      return data
    } catch (error) {
      console.error(error)
      throw error
    }
  },
  async replaceCreativeFiles({}, payload) {
    const url = `/api/social-products/social-boost/creatives/${payload.creative_id}/replace-file/${payload.file_id}`
    const formData = new FormData()

    payload.files.forEach((file, index) => {
      formData.append(`name`, file.name)
      formData.append(`size`, file.size)
      formData.append(`type`, file.type)
      formData.append(`raw`, file.raw)
    })

    try {
      const { data } = await axios.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      return data
    } catch (error) {
      console.error(error)
      throw error
    }
  },
  async sendCreativeToReview({}, payload) {
    const { data } = await axios.post(`/api/social-products/social-boost/creatives/${payload.creative_id}/change-status`, {
      status: 2,
    })
    return data
  },
  async sendAllCreativesToReview({}, payload) {
    const { data } = await axios.post(`/api/social-products/social-boost/creatives/${payload.flight_id}/change-status-all`, {
      status: 2,
    })
    return data
  },
  async approveCreative({}, payload) {
    const { data } = await axios.post(`/api/social-products/social-boost/creatives/${payload.creative_id}/change-status`, {
      status: 3,
    })
    return data
  },
  async requestCreativeRevision({}, payload) {
    const { data } = await axios.post(`/api/social-products/social-boost/creatives/${payload.creative_id}/change-status`, {
      status: 1,
      instructions: payload.instructions,
    })
    return data
  },

  async getAdUnits({ state, commit }) {
    const gam_network_id = state?.campaign?.publisher?.gam_network?.gam_network_id || this.getters['user/gam_network']
    if (gam_network_id) {
      const { data } = await axios.get(`/api/social-products/gam/${gam_network_id}/ad-units-list`)
      commit(
        'SET_ADUNITS',
        data.filter((item) => item.status === 'ACTIVE')
      )
    }
  },
  async getGamPresets({ state, commit }) {
    const publisher_id = state?.campaign?.publisher?.id || null
    if (publisher_id) {
      const { data } = await axios.get(`/api/social-products/gam/gam-presets/${publisher_id}`)
      commit('SET_GAM_PRESETS', data)
    }
  },
  async downloadCreative({}, payload) {
    const response = await axios.get(`/api/social-products/social-boost/creatives/${payload.creative_id}/download`, {
      responseType: 'blob',
    })
    return response
  },
}
